"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const NavLink_1 = require("components/NavLink");
//
// properties
//
const config_1 = require("assets/styles/config");
const activeClassName = 'nav-item-active';
exports.StyledLink = (0, styled_components_1.default)(NavLink_1.NavLink).attrs({ activeClassName }) `
  align-items: center;
  border-radius: 3px;
  color: ${config_1.colors.white};
  display: flex;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 35px;
  justify-content: ${({ justify }) => (justify ? justify : 'start;')};
  margin: 5px 15px;
  padding: ${({ sublink }) => sublink ? '5px 10px 5px 55px !important' : '5px 10px;'};
  &:hover,
  &:focus {
    /* 40% transparent */
    background: var(--p-color-bg-primary-active);
    color: ${config_1.colors.white};
  }
  &.${activeClassName} {
    background: var(--p-action-primary-hovered);
  }
`;
